import { ApigetLotterylist, ApigetLotteryLatelyLpVo, ApiqueryHisPeriodsPage } from "@/service";
import { Format } from "~/assets/libs/timeOptions";

export default {
    namespaced: true,
    state: {
        lotteryList: [], // 所有彩票列表
        lotteryTypes: [], // 所有彩种大类
        hotLotteryList: [], // 热门彩种
        LotteryLatelyLpVo: [], // 所有开奖彩种列表
        lotteryLatelyLpVoTimer: null, // 10S获取一次开奖号码的计时器
        lotteryTypeCode: 'PK10', // 当前彩种大类
        lotteryCode: "XYFT", // 当前彩种
        periodsNumber: "", // 当前期号
        historyrecord: false,

        page: 1, // 当前页
        totalPage: 20, // 总页数
        limit: 9999, // 每页条数
        totalCount: 1000, // 总条数
        ownDate: Format(new Date(), "yyyy-MM-dd"), // 开奖日期
        hisLotteryList: [], // 开奖历史列表
        lotteryNum: [], // 表格里面的开奖号码

        firstAddSecondpk: [], // pk10冠亚和
        oneFiveDragonTigerpk: [], // pk10 1-5龙虎
        zhishuNiuonXiong: [], //指数牛熊
        addAll: [], // k3总和
        sscAddAll: [], // ssc总和
        sscDragonTigerpk: [], // ssc 1-5龙虎
        lhcAddAll: [], // lhc总和
        theredAddAll: [],//3D
        ssqAddAll: [],//ssq总和
    },
    mutations: {
        // 设置所有彩票列表
        setLotteryList(state, payload) {
            state.lotteryList = payload;
        },
        // 设置彩票大类
        setLotteryTypes(state, payload) {
            state.lotteryTypes = payload;
        },
        // 设置热门彩种
        setHotLotteryList(state, payload) {
            state.hotLotteryList = payload;
        },
        // 设置彩种开奖计时器
        setLotteryLatelyTimer(state, payload) {
            console.log('5:设置新的彩种开奖计时器vuex', payload)
            state.lotteryLatelyLpVoTimer = payload;
        },
        // 清除获取彩种开奖计时器
        clearLotteryLatelyTimer(state) {
            console.log('1:清除循环获取彩种开奖列表的计时器' + state.lotteryLatelyLpVoTimer)
            clearInterval(state.lotteryLatelyLpVoTimer);
            console.log('2:计时器不在了···' + state.lotteryLatelyLpVoTimer)
        },
        // 设置所有彩种开奖列表
        setLotteryLatelyLpVo(state, payload) {
            state.LotteryLatelyLpVo = payload;
        },
        // 设置彩种大类
        setlotteryTypeCode(state, payload) {
            state.lotteryTypeCode = payload;
            state.periodsNumber = '';
        },
        // 设置彩种
        setlotteryCode(state, payload) {
            state.lotteryCode = payload;
            state.periodsNumber = '';
        },
        // 设置当前期号
        setperiodsNumber(state, payload) {
            state.periodsNumber = payload;
        },


        // 设置开奖历史列表
        setHisLotteryList(state, payload) {
            state.hisLotteryList = payload;
        },
        // 设置当前页
        setPage(state, payload) {
            state.page = payload;
        },
        // 设置总页数
        setTotalPage(state, payload) {
            state.totalPage = payload;
        },
        // 设置总条数
        setTotalCount(state, payload) {
            state.totalCount = payload;
        },
        // 设置每页条数
        setLimit(state, payload) {
            state.limit = payload;
        },
        // 设置开奖日期
        setOwnDate(state, payload) {
            state.ownDate = payload;
        },
        //
        // 以下均为表格中的数据，均为arr[arr]
        //
        // 设置表格里面的开奖号码
        setLotteryNum(state, payload) {
            state.lotteryNum = payload;
        },
        // 设置pk10冠亚和
        setFirstAddSecondpk(state, payload) {
            state.firstAddSecondpk = payload;
        },
        // 设置pk10 1-5龙虎
        setOneFiveDragonTigerpk(state, payload) {
            state.oneFiveDragonTigerpk = payload;
        },
        // 设置指数牛熊
        setZhishuNiuonXiong(state, payload) {
            state.zhishuNiuonXiong = payload;
        },
        // 设置k3 总和
        setAddAll(state, payload) {
            state.addAll = payload;
        },
        // 设置3d 总和
        setTheredAddAll(state, payload) {
            state.theredAddAll = payload;
        },
        // 设置ssc 总和
        setSSCAddAll(state, payload) {
            state.sscAddAll = payload;
        },
        setSSQAddAll(state, payload) {
            state.ssqAddAll = payload;
        },
        // 设置ssc 1-5龙虎
        setSSCDragonTigerpk(state, payload) {
            state.sscDragonTigerpk = payload;
        },
        // 设置lhc 1-5龙虎
        setLHCAddAll(state, payload) {
            state.lhcAddAll = payload;
        },
        // 设置lhc 1-5龙虎
        setHistoryRecord(state, payload) {
            state.historyrecord = payload;
        },
    },
    actions: {
        // 获取所有彩种
        getLotterylist({ state, commit, rootState }) {
            //缓存 只取一次
            return new Promise(async (resolve, reject) => {
                let res = await ApigetLotterylist()
                if (res.code == '12200') {
                    for (let item of res.data) { // 计算当前期数(首页写完了才发现详情页也要用，遂改为这里)
                        if (item.periodsNumberAddRule == 2) {
                            let r = await ApiqueryHisPeriodsPage({ lotteryCode: item.lotteryCode, limit: 5000 })
                            item.uziyongyuandeshen = r.data.list.length; // 当前期数
                        }
                    }
                    commit('setLotteryList', res.data); // 所有彩种

                    // 大类排序
                    let LotteryTypes = [];
                    res.data.forEach(item => {
                        if (!LotteryTypes.some(xitem => xitem.lotteryTypeCode == item.lotteryTypeCode)) {
                            LotteryTypes.push(item)
                        }
                    })
                    commit('setLotteryTypes', LotteryTypes)

                    // 热门
                    let hotList = res.data.filter(item => item.isHot == 1)
                    commit('setHotLotteryList', hotList)
                    resolve(res.data);
                    return;
                }
                resolve([])

            })
        },
        // // 首页热门彩种计算当前期数
        // uziyongyuandeshen({ state, commit }) {
        //     return new Promise(async (resolve, reject) => {
        //         let { hotLotteryList, ownDate } = state
        //         for (let item of hotLotteryList) {
        //             if (item.periodsNumberAddRule == 2) {
        //                 let res = await ApiqueryHisPeriodsPage({ lotteryCode: item.lotteryCode, limit: 5000, ownDate })
        //                 item.uziyongyuandeshen = res.data.list.length; // 当前期数
        //                 commit('setHotLotteryList', hotLotteryList)
        //             }
        //         }
        //         resolve([])
        //     })
        // },
        // 得到所有彩票开奖详情
        getLotteryLatelyLpVo({ state, commit, rootState }) {
            //缓存 只取一次
            return new Promise(async (resolve, reject) => {
                let res = await ApigetLotteryLatelyLpVo()
                if (res.code == '12200') {
                    let list = res.data;
                    list.forEach(list => {
                        if (list.current == undefined) {
                            list.status = 'next';
                        } else {
                            list.status = 'current';
                        }
                    })
                    commit('setLotteryLatelyLpVo', res.data)
                    console.log('4:更新开奖时间列表')

                    // //设置当前期数
                    // let lottery = list.find(e => {
                    //     //找到当前彩种
                    //     return e.lotteryCode == state.lotteryCode
                    // })

                    resolve(res.data);
                }
            })
        },
        // 10秒获取一次开奖彩票详情
        getLotteryLatelyLoop({ state, dispatch, commit }) {
            return new Promise((resolve, reject) => {
                //循环获取彩种开奖列表
                let res = dispatch('getLotteryLatelyLpVo').then(() => {
                    clearInterval(state.lotteryLatelyLpVoTimer)
                    state.lotteryLatelyLpVoTimer = setInterval(() => {
                        dispatch('getLotteryLatelyLpVo');
                        dispatch('service/getServiceTime', false, { root: true })
                        dispatch('queryHisPeriodsPage'); // 待定
                    }, 10000)
                    resolve(res);
                });
            })
        },


        // 开奖历史
        queryHisPeriodsPage({ state, commit, rootState }) {
            return new Promise(async (resolve, reject) => {
                let { lotteryTypeCode, lotteryCode, limit, ownDate, page } = state;
                if(!lotteryTypeCode) return
                if(!lotteryCode) return
                let res = await ApiqueryHisPeriodsPage({ lotteryCode, limit, page })
                if (res.code == '12200') {
                    if (res.data.list.length == 0) {
                        // 无记录
                        commit('setHistoryRecord', true);
                    } else {
                        commit('setHistoryRecord', false);
                    }
                    // 总开奖数据
                    commit('setHisLotteryList', res.data.list);
                    commit('setPage', res.data.currPage);
                    commit('setTotalCount', res.data.totalCount);
                    // 表格里面的号码
                    let numList = res.data.list.map(item => item.drawingNumber).map(item => item.split(","));
                    commit('setLotteryNum', numList);
                    let tool1 = []; // 冠亚和(3个数据)
                    let tool2 = []; // 龙虎(5个数)
                    let tool3 = [];
                    for (let item of numList) {
                        if (lotteryTypeCode == "PK10") {
                            let add = [];
                            let num = item[0] * 1 + item[1] * 1;
                            let bigSmall = num > 11 ? "大" : "小";
                            let oddEven = (num % 2 == 0) ? "双" : "单";
                            add.push(num, bigSmall, oddEven);
                            tool1.push(add);

                            let battle = [];
                            if (item[0] > item[9]) { battle.push("龙") } else { battle.push("虎") }
                            if (item[1] > item[8]) { battle.push("龙") } else { battle.push("虎") }
                            if (item[2] > item[7]) { battle.push("龙") } else { battle.push("虎") }
                            if (item[3] > item[6]) { battle.push("龙") } else { battle.push("虎") }
                            if (item[4] > item[5]) { battle.push("龙") } else { battle.push("虎") }
                            tool2.push(battle)
                        } else if (lotteryTypeCode == "SSQ"||lotteryTypeCode == "DLT") {
                            let add = [];
                            // let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
                            let num = item.reduce((a, b) => { return a * 1 + b * 1 })
                            let oddEven = (num % 2 == 0) ? "双" : "单";
                            add.push(num, oddEven);
                            tool1.push(add);
                        } else if (lotteryTypeCode == "K3" || lotteryTypeCode == "LHC") {
                            let add = [];
                            // let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
                            let num = item.reduce((a, b) => { return a * 1 + b * 1 })
                            let bigSmall = num > 10 ? "大" : "小";
                            let oddEven = (num % 2 == 0) ? "双" : "单";
                            if (lotteryTypeCode == "LHC") {
                                let sebo = [
                                    {
                                        code: "红",
                                        list: [
                                            "01",
                                            "02",
                                            "07",
                                            "08",
                                            "12",
                                            "13",
                                            "18",
                                            "19",
                                            "23",
                                            "24",
                                            "29",
                                            "30",
                                            "34",
                                            "35",
                                            "40",
                                            "45",
                                            "46"
                                        ]
                                    },
                                    {
                                        code: "蓝",
                                        list: [
                                            "03",
                                            "04",
                                            "09",
                                            "10",
                                            "14",
                                            "15",
                                            "20",
                                            "25",
                                            "26",
                                            "31",
                                            "36",
                                            "37",
                                            "41",
                                            "42",
                                            "47",
                                            "48"
                                        ]
                                    },
                                    {
                                        code: "绿",
                                        list: [
                                            "05",
                                            "06",
                                            "11",
                                            "16",
                                            "17",
                                            "21",
                                            "22",
                                            "27",
                                            "28",
                                            "32",
                                            "33",
                                            "38",
                                            "39",
                                            "43",
                                            "44",
                                            "49"
                                        ]
                                    }
                                ]
                                let color = sebo.find(e => e.list.includes(item[item.length - 1]));
                                add.push(num, bigSmall, oddEven, color.code);
                            } else {
                                add.push(num, bigSmall, oddEven);
                            }
                            tool1.push(add);
                        } else if (lotteryTypeCode == "PCDD") {
                            let add = [];
                            let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
                            let bigSmall = num > 13 ? "大" : "小";
                            let oddEven = (num % 2 == 0) ? "双" : "单";
                            add.push(num, bigSmall, oddEven);
                            tool1.push(add);
                        } else if (lotteryTypeCode == "SSC" || lotteryTypeCode == "11X5") {
                            let add = [];
                            // let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
                            let num = item.reduce((a, b) => { return a * 1 + b * 1 })
                            let bigSmall = num > 22 ? "大" : "小"; // 仅ssc
                            let oddEven = (num % 2 == 0) ? "双" : "单";
                            add.push(num, bigSmall, oddEven);
                            tool1.push(add);

                            let battle = [];
                            if (item[0] > item[4]) { battle.push("龙") } else if (item[0] == item[4]) { battle.push("和") } else { battle.push("虎") }
                            tool2.push(battle)
                        } else if (lotteryTypeCode == "3D" || lotteryTypeCode == "PL3") {
                            let add = [];
                            // let num = item[0] * 1 + item[1] * 1 + item[2] * 1;
                            let num = item.reduce((a, b) => { return a * 1 + b * 1 })
                            let bigSmall = num > 13 ? "大" : "小";
                            let oddEven = (num % 2 == 0) ? "双" : "单";
                            add.push(num, bigSmall, oddEven);
                            tool1.push(add);
                        } else if (lotteryTypeCode == "ZHISHU") {
                            let battle = [];
                            if (item[0] > item[1]) { battle.push("牛") } else { battle.push("熊") }
                            tool3.push(battle)
                        }
                    }
                    // pk10
                    commit('setFirstAddSecondpk', tool1);
                    commit('setOneFiveDragonTigerpk', tool2);
                    // k3 || pcdd
                    commit('setAddAll', tool1);
                    commit('setTheredAddAll', tool1);
                    // ssc || 11x5
                    commit('setSSCAddAll', tool1);
                    commit('setSSCDragonTigerpk', tool2);
                    // lhc
                    commit('setLHCAddAll', tool1);
                    //ssq
                    commit('setSSQAddAll', tool1)
                    // zhishu
                    commit('setZhishuNiuonXiong', tool3)
                }
            })
        },
    }
}